export {default} from './ImageMessage';



// WEBPACK FOOTER //
// ./src/components/ChatUI/ImageMessage/index.ts